<!-- <li class="panel"> -->
<div class="controparte">
	<div>
	<p class="col-sm-2">
			<button (click)="emitEntity(parcellaGiudiziale)" class="btn btn-primary associa"
				type="submit">Allega</button>
		</p>
		<h4 class="titolo col-sm-3">{{parcellaGiudiziale.legale?.legale.nominativo}}
		</h4>
		<p class="col-sm-2">
			<strong>{{parcellaGiudiziale.legale?.categoriaLegaleIncaricato.label}}</strong>
		</p>
		<p class="col-sm-3">
			Parcella <strong>{{parcellaGiudiziale.numeroParcella}}</strong> del <strong>{{parcellaGiudiziale.dataParcella
				| date:'dd/MM/yyyy'}}</strong>
		</p>
		<p class="col-sm-2">
			Valore: <strong>{{parcellaGiudiziale.importoParcella | euro
				}} &euro;</strong>
		</p>
	</div>
</div>
<!-- </li> -->
